export default __webpack_public_path__ + "static/media/slide3.99f7cd40.jpg";